import React from "react";
import { LegalComplianceChatbot } from "@root/components/LegalComplianceChatbot/LegalComplianceChatbot";

export const LegalCompliancePage: React.FC = () => {
  return <LegalComplianceChatbot />;
};
